<template>
  <div class="wrapper_dark" @click="interactCheck" @touchstart="interactCheck" @touchmove="interactCheck">
    <div class="header">
      <button class="btn_back" @click="back">
        <img src="@/assets/img/left-arrow.svg" />
      </button>
      <h1 class="title">{{ $tc("menu_selection") }}</h1>
      <button class="btn_exit" @click="goHome">{{ $tc("cancle") }}</button>
    </div>
    <div class="menu_order_wrap">
      <div class="category_wrap">
        <div class="category_item" v-for="category in categoryList" :key="category.idx" :class="{selected: category.isSelected}"
         @click="changeSelectCateory(category)">
          {{ category.name }}
        </div>
      </div>
      <div class="menu_wrap">
        <div class="menu_scroll_wrap">
          <div class="menu_text">{{ displayMenuText }}</div>
          <div class="category_menus" v-for="category in selectedCategory.menus" :key="`menu_${category._id}`">
            <div class="category_title">{{ category.name || category.categoryName }}</div>
            <div class="menu_card_wrap">
              <div v-for="menu in category.menus" :key="menu.idx" class="menu_card" :class="{soldout: menu.isSoldOut}"
               @click="openMenuSelectPopup(menu)">
                <div class="menu_info">
                  <div class="tags">
                    <div class="tag" :class="[tag.class, locale]" v-for="(tag, idx) in menuTags(menu)" :key="`${menu._id}_${idx}`">{{ tag.name }}</div>
                  </div>
                  <div class="name">{{ menu.name }}</div>
                  <div class="price">{{ displayPrice(menu.sizes) }}</div>
                </div>
                <div class="menu_status">
                  <div v-if="(menu.isSoldOut)" class="status">{{ $tc('soldOut') }}</div>
                  <div v-else-if="(menu.restrictionType !== 'NO_LIMIT')" class="status">{{ $tc('maxOrderCount', menu.maxPermittedQuantity) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="selected_menu_wrap">
        <div class="selected_menu_list">
          <div class="count">
            <div class="count_text">{{ $tc('addedMenus') }}</div>
            <div class="count_num">{{ `${selectedMenusTotalCount}${$tc('number')}` }}</div>
          </div>
          <div v-if="(selectedMenuList.size === 0)">
            <div class="no_select_menus" v-html="$tc('noMenu')"></div>
          </div>
          <div v-else class="menu_list_wrap">
            <div class="selected_menu" v-for="(menu, idx) in displaySelectedMenuList" :key="`${menu._id}_${idx}`">
              <div class="selected_menu_title">
                <div class="menu-name">{{ `${(menu.isMain) ? `[${$tc('main')}] ` : ''}${menu.name}` }}</div>
                <div class="qty-wrap">
                  <div class="menu-quantity">{{ menu.quantity }}</div>
                  <div class="menu-delete" @click="removeMenuInSelectedMenuList(menu)">
                    <img src="@/assets/close.png" />
                  </div>
                </div>
              </div>
              <div v-if="menu.isError" class="selected_menu_error_text">{{ menu.errMsg }}</div>
              <div class="selected_menu_size">{{ menu.size.name }}</div>
              <div class="selected_menu_options">{{ getSelectedOptiosToString(menu) }}</div>
              <div v-if="!menu.isError" class="change_button_wrap" @click="openMenuModifyPopup(menu)">{{ $tc('change') }}</div>
            </div>
          </div>
        </div>
        <div class="total">
          <div class="total_text">{{ $tc('totalAmount') }}</div>
          <div class="total_num">{{ $tc('won', totalOrderPrice) }}</div>
        </div>
        <div class="next_button" :class="{active: isActive}" @click="next">{{ this.isValidating ? $tc('loding') :  $tc('next') }}</div>
      </div>
    </div>
    <MenuSelectPopup v-if="openSelectPopup" :menu="selectMenu" :outOfStockSetQuantity="menuInfo.outOfStockSetQuantity" :isModifing="isModifing" :remainCnt="remainSelectableCnt" :useOnePersonOneMenuOrder="menuInfo.useOnePersonOneMenuOrder"
      :useMenuOptionQuantity="restaurant.useMenuOptionQuantity"
      :selected-menu-list="selectedMenuList"
      @addSelectedMenu="addSelectedMenu"
      @closePopup="() => { openSelectPopup = false }" />
    <Popup v-show="showPopup" @popControl="popup" />
    <AlertPopup v-if="isAlert" :msg="msg" @AlertEvent="alertAction" />
    <timeout-popup :isShow="isShowTimeOutPop" @moveToHome="moveToHome" @close="closeTimeoutPopup"/>
  </div>
</template>

<script>
import { timeout } from './mixins/timeout'
import timeoutPopup from '@/components/TimeOutPopup.vue'
import { validateOrderMenu } from '@/api/waiting'
import AlertPopup from '@/components/AlertPopup'
import { numberWidthComma } from '../utills'
import MenuSelectPopup from '@/components/MenuSelectPopup'
import Popup from '@/components/Popup.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'MenuView',
  mixins: [timeout],
  components: { timeoutPopup, MenuSelectPopup, Popup, AlertPopup },
  computed: {
    // ...mapState(['restaurant', 'restaurantMenuInfo', 'waitingParams', 'locale']),
    ...mapState(['restaurantMenuInfo', 'locale']),
    ...mapGetters({ restaurant: 'getRestaurantInfo', waitingParams: 'getWaitingParams', storeIdx: 'getStoreIdx' }),
    displayMenuText () {
      let text = this.$tc('select_menu')
      if (this.restaurant.useOnePersonOneMenuOrder) {
        if (this.restaurantMenuInfo.mainMenuOrder) {
          const min = this.restaurantMenuInfo.mainMenuOrder.min
          const max = this.restaurantMenuInfo.mainMenuOrder.max
          text = (min === max) ? this.$tc('oneMenuPerPersonMax', max) : `${this.$tc('oneMenuPerPersonMinMax', min)}${this.$tc('oneMenuPerPersonMinMax_2', max)}`
        }
      }
      return text
    },
    selectedMenusTotalCountOnlyMainMenu () {
      let totalCnt = 0
      if (this.displaySelectedMenuList.length > 0) {
        this.displaySelectedMenuList.forEach((menu) => {
          if (menu.isMain) {
            totalCnt = totalCnt + Number(menu.quantity)
          }
        })
      }
      return totalCnt
    },
    selectedMenusTotalCount () {
      let totalCnt = 0
      if (this.displaySelectedMenuList.length > 0) {
        this.displaySelectedMenuList.forEach((menu) => {
          totalCnt = totalCnt + Number(menu.quantity)
        })
      }
      return totalCnt
    },
    totalOrderPrice () {
      let calcPrice = 0
      if (this.displaySelectedMenuList.length > 0) {
        this.displaySelectedMenuList.forEach((menu) => {
          calcPrice += (Number(menu.price) * Number(menu.quantity))
        })
      }
      return numberWidthComma(calcPrice)
    }
  },
  // watch
  data () {
    return {
      msg: this.$tc('maximumQuantityOfMainMenu'),
      isAlert: false,
      isActive: false,
      remainSelectableCnt: -1,
      modifiedId: '',
      isModifing: false,
      displaySelectedMenuList: [],
      showPopup: false,
      isValidating: false,
      menuInfo: {
        outOfStockSetQuantity: 0,
        useOnePersonOneMenuOrder: false,
        canTotalOrder: {},
        list: []
      },
      categoryList: [
        {
          name: this.$tc('all_menus'),
          isSelected: true,
          menus: []
        }
      ],
      selectedCategory: {
        name: this.$tc('all_menus'),
        isSelected: true,
        menus: []
      },
      selectedMenuList: new Map(),
      selectMenu: {},
      openSelectPopup: false
    }
  },
  methods: {
    alertAction () {
      this.isAlert = false
    },
    /**
     * @description 선택된 옵션들을 안줄로 반환 (수량 2개 이상이면 수량 표기)
     * @param {object} menu
     * @returns {string}
     */
    getSelectedOptiosToString (menu) {
      let text = ''
      if (menu.options.length > 0) {
        menu.options.forEach(option => {
          const name = (option.quantity > 1) ? `${option.name} (${this.$tc('unitCount', option.quantity)})` : option.name
          text = (text.length > 0) ? `${text}, ${name}` : name
        })
      }
      return text
    },
    /**
     * @description 메뉴 식별 키 생성 (메뉴 + 사이즈 + 옵션 + 옵션 수량 기준)
     * @param {object} menu
     * @returns {string}
     */
    buildMenuKey (menu) {
      const optionIds = menu.options.map(option => `${option._id}:${option.quantity || 1}`).join()
      return `${menu._id}${menu.size._id}${optionIds}`
    },
    /**
     * @description displaySelectedMenuList 갱신
     * @returns {void}
     */
    setDisplaySelectedMenuList () {
      this.displaySelectedMenuList = Array.from(this.selectedMenuList.values())
      this.isActive = this.selectedMenuList.size
    },
    /**
     * @description selectedMenuList에서 선택된 메뉴 제거
     * @param {object} menu
     * @returns {void}
     */
    removeMenuInSelectedMenuList (menu) {
      this.selectedMenuList.delete(this.buildMenuKey(menu))
      if (menu.isMain) { this.remainSelectableCnt = Number(this.remainSelectableCnt) + Number(menu.quantity) }
      this.setDisplaySelectedMenuList()
    },
    /**
     * @description selectedMenuList에 선택된 메뉴 추가
     * @param {object} menu
     * @returns {void}
     */
    addSelectedMenu (menu, isModified) {
      if (isModified) {
        const qty = this.selectedMenuList.get(this.modifiedId).quantity
        this.selectedMenuList.delete(this.modifiedId)
        if (menu.isMain) { this.remainSelectableCnt = Number(this.remainSelectableCnt) + Number(qty) }
      }
      const key = this.buildMenuKey(menu)
      if (this.selectedMenuList.has(key)) {
        const oldMenu = this.selectedMenuList.get(key)
        if (menu.isMain) { this.remainSelectableCnt = Number(this.remainSelectableCnt) + Number(oldMenu.quantity) }
        menu.quantity = Number(oldMenu.quantity) + Number(menu.quantity)
      }
      this.selectedMenuList.set(key, menu)
      if (menu.isMain) { this.remainSelectableCnt = Number(this.remainSelectableCnt) - Number(menu.quantity) }
      this.setDisplaySelectedMenuList()
    },
    /**
     * @description 선택한 메뉴가 주문 가능한지 검증
     * @returns {Boolean}
     */
    async validateSelectedMenu () {
      // 이미 검증 중이면 실행 무시
      if (this.isValidating) {
        return false
      }

      this.isValidating = true

      try {
        let menus = []
        const selectedMenus = Array.from(this.selectedMenuList.values())
        if (selectedMenus.length > 0) {
          menus = selectedMenus.map(menu => {
            const { _id, name, price, isMain, isSoldOut, quantity } = menu
            const size = { name: menu.size.name, price: menu.size.price, _id: menu.size._id }
            const options = menu.options.map(option => {
              option.isSoldOut = false
              return option
            })
            return { _id, name, price, isMain, isSoldOut, quantity, size, options }
          })
        }
        const { data } = await validateOrderMenu({ orderMenus: menus }).catch((err) => {
          console.error('validateOrderMenu error---', err)
        })
        if (data.errorCount > 0) {
          await this.$store.dispatch('setRestaurantMenuList')
          this.categoryList = [
            {
              name: this.$tc('all_menus'),
              isSelected: true,
              menus: this.restaurantMenuInfo.list
            }
          ]
          this.changeSelectCateory({ name: this.$tc('all_menus') })
          this.restaurantMenuInfo.list.forEach((category) => {
            this.categoryList.push({
              idx: category.idx,
              name: category.name,
              isSelected: false,
              menus: [
                {
                  categoryName: category.name,
                  menus: category.menus
                }
              ]
            })
          })
          data.list.forEach((menu) => {
            if (menu.error) {
              const key = this.buildMenuKey(menu)
              const oldinfo = this.selectedMenuList.get(key)
              oldinfo.isError = true
              oldinfo.errMsg = (menu.error.code === 'SOLD_OUT_MENU') ? this.$tc('orderImpossibleBySoldOut') : this.$tc('removeAndPut')
              this.selectedMenuList.set(key, oldinfo)
            }
          })
        }
        return (data.errorCount === 0)
      } finally {
        this.isValidating = false
      }
    },
    async next () {
      if (!this.isActive || this.isValidating) { return false }
      if (await this.validateSelectedMenu()) {
        this.$store.commit('setWaitingParams', { menus: this.selectedMenuList })
        this.$router.push('/confirm')
      } else {
        this.isAlert = true
        this.msg = this.$tc('impossibleOrder_v2')
      }
    },
    openMenuModifyPopup (targetMenu) {
      let tempMenu = {}
      this.restaurantMenuInfo.list.forEach(category => {
        category.menus.forEach(menu => {
          if (menu._id === targetMenu._id) tempMenu = JSON.parse(JSON.stringify(menu))
        })
      })
      tempMenu.sizes.forEach(size => {
        size.isSelected = (targetMenu.size._id === size._id)
      })
      tempMenu.optionGroups.forEach(group => {
        group.options.forEach(option => {
          let isSelected = false
          let quantity = 0
          targetMenu.options.forEach(selectedOption => {
            if (option._id === selectedOption._id) {
              isSelected = true
              quantity = selectedOption.quantity || 1
            }
          })
          option.isSelected = isSelected
          option.quantity = quantity
        })
      })
      tempMenu.quantity = targetMenu.quantity
      this.modifiedId = this.buildMenuKey(targetMenu)
      this.openMenuSelectPopup(tempMenu, true)
    },
    openMenuSelectPopup (menu, isModifing = false) {
      if (menu.isSoldOut) return
      if (!isModifing && menu.restrictionType !== 'NO_LIMIT') {
        const keys = this.selectedMenuList.keys()
        const tempKeys = []
        for (var key of keys) {
          if (key.includes(menu._id)) {
            tempKeys.push(key)
          }
        }
        let qty = 0
        tempKeys.forEach((key) => {
          qty = qty + this.selectedMenuList.get(key).quantity
        })
        if (menu.maxPermittedQuantity <= qty) {
          this.msg = this.$tc('maximumQuantity')
          this.isAlert = true
          return
        }
      }
      if (!isModifing && menu.isMain && this.remainSelectableCnt === 0) {
        this.msg = this.$tc('maximumQuantityOfMainMenu')
        this.isAlert = true
        return
      }
      this.isModifing = isModifing
      this.selectMenu = menu
      this.openSelectPopup = true
    },
    displayPrice (sizes) {
      const tempSize = sizes.map(size => size)
      tempSize.sort((a, b) => {
        if (a.price < b.price) { return -1 }
        if (a.price > b.price) { return 1 }
        return 0
      })
      let str = `${tempSize[0].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`
      if (tempSize.length > 1) {
        str = `${str} ~`
      }
      return str
    },
    menuTags (menu) {
      const list = []
      if (menu.isFeatured) {
        list.push(
          { name: this.$tc('best'), class: 'featured' }
        )
      }
      if (menu.isMain) {
        list.push(
          { name: this.$tc('main'), class: 'main' }
        )
      }
      if (menu.restrictionType !== 'NO_LIMIT') {
        list.push(
          { name: this.$tc('limted'), class: 'limited' }
        )
      }
      return list
    },
    changeSelectCateory (selectedCateroy) {
      this.categoryList.forEach((category) => {
        category.isSelected = (category.name === selectedCateroy.name)
        if (category.name === selectedCateroy.name) {
          this.selectedCategory = category
        }
      })
    },
    goHome () {
      this.showPopup = true
    },
    popup (type) {
      if (type === 'cancle') {
        this.$router.push('/')
      } else {
        this.showPopup = false
      }
    },
    back () {
      this.$router.push('/select-person')
    }
  },
  // updated
  // mounted
  async created () {
    await this.$store.dispatch('setRestaurant', this.storeIdx)
    await this.$store.dispatch('setRestaurantMenuList')

    this.selectedMenuList = this.waitingParams.menus
    Array.from(this.selectedMenuList.values()).map((menu) => {
      const key = this.buildMenuKey(menu)
      const oldinfo = this.selectedMenuList.get(key)
      oldinfo.isError = false
      oldinfo.errMsg = ''
      this.selectedMenuList.set(key, oldinfo)
    })
    this.setDisplaySelectedMenuList()
    this.menuInfo = this.restaurantMenuInfo
    this.categoryList[0].menus = this.restaurantMenuInfo.list
    this.selectedCategory.menus = this.restaurantMenuInfo.list
    this.menuInfo.list.forEach((category) => {
      this.categoryList.push({
        idx: category.idx,
        name: category.name,
        isSelected: false,
        menus: [
          {
            categoryName: category.name,
            menus: category.menus
          }
        ]
      })
    })
    this.remainSelectableCnt = (this.menuInfo.useOnePersonOneMenuOrder) ? this.restaurantMenuInfo.mainMenuOrder.max : -1
    this.remainSelectableCnt = Number(this.remainSelectableCnt) - Number(this.selectedMenusTotalCountOnlyMainMenu)
    if (this.$route.params.runValidate) { this.validateSelectedMenu() }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/base.scss";

.wrapper_dark {
  position: relative;
}
.menu_order_wrap {
  display: flex;
  height: 730px;
  padding: 24px 16px;
  background: $gray_50;
  .category_wrap {
    flex: 0 0 196px; // 브라우저 가로폭이 줄어도 카테고리 영역은 줄어들지 않는다 (172px 항목 + 좌우 padding 12px)
    width: 196px;
    padding: 12px;
    border-radius: 24px;
    background: $gray_200;
    overflow-y: scroll;
    .category_item {
      width: 172px;
      margin-bottom: 16px;
      padding: 16px;
      font-size: 24px;
      color: $gray_900;
      word-wrap:break-word;
      line-height: 1.5;
      &.selected {
        padding: 14px 16px;
        background: $white;
        border: 2px solid $indigo;
        box-shadow: 2px 6px 8px rgba(19, 21, 23, 0.25);
        border-radius: 16px;
        font-weight: bold;
        color: $indigo;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .menu_wrap {
    width: 100%;
    max-width: 698px;
    .menu_text {
      padding: 0 36px;
      margin: 32px 0;
      font-size: 32px;
      color: $gray_900;
      line-height: 1.5;
    }
    .category_menus {
      padding: 0 36px;
      margin-top: 16px;
      &:first-child {
        margin-top: 0;
      }
    }
    .category_title {
      padding-left: 16px;
      margin-bottom: 16px;
      font-size: 24px;
      color: $gray_900;
      word-break: break-all;
    }
    .menu_scroll_wrap {
      height: 706px;
      overflow-y: scroll;
      .menu_card_wrap {
        display: flex;
        flex-wrap: wrap;
        // 카드마다 오른쪽 16px 여백을 주고 래퍼를 -16px 로 당겨 줄 끝 여백을 상쇄한다
        // (nth-child(3n) 방식은 한 줄에 2개만 들어갈 때 2번째 줄 첫 카드의 여백이 사라져 카드끼리 붙는 문제가 있었다)
        margin-right: -16px;
        .menu_card {
          width: 198px;
          height: 198px;
          margin: 0 16px 16px 0;
          background: $white;
          box-shadow: -4px -4px 16px rgba(19, 21, 23, 0.05), 4px 4px 8px rgba(19, 21, 23, 0.15);
          border-radius: 16px;
          cursor: pointer;
          .menu_info {
            height: 158px;
            // padding: 10px;
            .tags {
              display: flex;
              height: 40px;
              padding: 16px 16px 0;
              margin-bottom: 4px;
              .tag {
                padding: 4px;
                margin-right: 4px;
                font-size: 16px;
                border-radius: 4px;
                &.featured {
                  background: $green_12;
                  color: $green;
                }
                &.main {
                  background: $deep_blue_6;
                  color: $deep_blue;
                }
                &.limited {
                  background: $orange_6;
                  color: $orange;
                }
                &.cn_simplified {
                  font-size: 15px;
                }
              }
            }
            .name {
              max-height: 72px;
              font-size: 24px;
              font-weight: bold;
              color: $gray_900;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              word-wrap:break-word;
              line-height: 1.5;
              padding: 0 16px;
              margin-bottom: 8px;
            }
            .price {
              background: $gray_100;
              border-radius: 8px;
              padding: 6px 8px;
              margin: 0 16px;
              font-size: 18px;
              color: $gray_800;
              line-height: 1;
            }
          }
          .menu_status {
            padding: 10px 6px 0;
            .status {
              width: 100%;
              padding: 4px;
              font-size: 16px;
              background: $orange;
              border-radius: 12px;
              color: $white;
              line-height: 1;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-wrap:break-word;
            }
          }
          &.soldout {
            border: 2px solid transparent;
            background-image: linear-gradient($gray_400, $gray_400), linear-gradient(to right bottom, rgba(109, 117, 131, 0.1), rgba(109, 117, 131, 1));
            background-origin: border-box;
            background-clip: content-box, border-box;
            .menu_info {
              opacity: 0.5;
            }
            .menu_status {
              padding: 8px 4px 0;
              .status {
                background: $gray_800;
              }
            }
          }
        }
      }
    }
  }
  .selected_menu_wrap {
    padding: 16px;
    background: $white;
    box-shadow: 4px 8px 12px rgba(19, 21, 23, 0.15);
    border-radius: 24px;
    .selected_menu_list {
      width: 322px;
      height: 506px;
      padding: 24px 16px 0 16px;
      background: $gray_100;
      border-radius: 16px;
      .count {
        display: flex;
        justify-content: space-between;
        padding-bottom: 16px;
        border-bottom: 1px $gray_400 solid;
        .count_text, .count_num {
          font-size: 24px;
          color: $gray_900;
        }
      }
      .no_select_menus {
        padding-top: 180px;
        font-size: 18px;
        color: $gray_600;
        text-align: center;
        line-height: 1.5;
      }
      .menu_list_wrap {
        height: 437px;
        overflow-y: scroll;
      }
      .selected_menu {
        padding-bottom: 8px;
        border-bottom: 1px solid $e0;
        &:last-child {
          border-bottom: none;
        }
        .selected_menu_title {
          display: flex;
          justify-content: space-between;
          height: 24px;
          line-height: 24px;
          margin-top: 16px;
          color: $gray_900;
          font-weight: bold;
          font-size: 18px;
          .menu-name {
            width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .qty-wrap {
            display: flex;
          }
          .menu-quantity {
            width: 40px;
            text-align: right;
          }
          .menu-delete, .menu-quantity {
            padding-left: 16px;
          }
        }
        .selected_menu_error_text {
          margin-top: 8px;
          color: $danger;
        }
        .selected_menu_size, .selected_menu_options {
          padding-top: 5px;
          font-size: 16px;
          color: $gray_600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.5   ;
        }
        .change_button_wrap {
          display: inline-block;
          margin-top: 8px;
          background: $layer;
          border-radius: 8px;
          width: auto;
          height: 34px;
          padding: 8px 12px;
          color: $orange;
          font-weight: bold;
          font-size: 18px;
          cursor: pointer;
        }
      }
    }
    .total {
      display: flex;
      justify-content: flex-end;
      padding: 20px 0;
      .total_text, .total_num {
        font-size: 24px;
      }
      .total_text {
        margin-right: 16px;
        color: $gray_600;
      }
      .total_num {
        font-weight: bold;
        color: $orange;
      }
    }
    .next_button {
      padding: 24px;
      text-align: center;
      background: $gray_400;
      border-radius: 16px;
      font-size: 24px;
      font-weight: bold;
      color: $white;
      &.active {
        background: $light_blue;
      }
    }
  }
}
</style>
